import axios from 'axios';
import persistenceService from './persistence-service';
import { useMessageContext } from '../libraries/contexts';

const { REACT_APP_API_URL } = process.env;
const SERVER_API = REACT_APP_API_URL;
const PREFIX = 'configuration';

const headers = {
  'Content-Type': 'application/json; charset=utf-8'
};

const publicInstance = axios.create({
  baseURL: SERVER_API,
  timeout: 300000,
  crossdomain: true,
  headers
});

publicInstance.interceptors.response.use(
  response => response,
  error => {
    try {
      const [value, setValue] = useMessageContext();
      setValue(error);
    } catch (er) {}
    if (
      error.response &&
      error.response.data &&
      error.response.data.message &&
      error.response.data.message.toLowerCase().includes('token')
    ) {
      persistenceService.clearPersistentDataProps();
      window.location.reload();
    }
    throw error;
  }
);

publicInstance.interceptors.request.use(
  config => {
    const access_token = persistenceService.get('token');

    if (access_token !== null) {
      config.headers.Authorization = `${access_token}`;
    }
    if (!access_token && !config.url.includes('login')) {
      window.location.reload();
    }
    return config;
  },
  err => {
    return Promise.reject(err);
  }
);

const ConfigurationService = {
  async setDailyClosing(json) {
    try {
      const res = await publicInstance.post(
        `${SERVER_API}${PREFIX}/daily-closing/`,
        JSON.stringify(json)
      );
      const { data } = await res;
      return data;
    } catch (err) {
      const {
        response: { data }
      } = await err;

      throw data;
    }
  },
  async getDailyClosing(json) {
    try {
      const res = await publicInstance.get(
        `${SERVER_API}${PREFIX}/daily-closing/`,
        JSON.stringify(json)
      );
      const { data } = await res;
      return data;
    } catch (err) {
      const {
        response: { data }
      } = await err;

      throw data;
    }
  },
  async setGuestsUpdate(json) {
    try {
      const res = await publicInstance.post(
        `${SERVER_API}${PREFIX}/guests-update/`,
        JSON.stringify(json)
      );
      const { data } = await res;
      return data;
    } catch (err) {
      const {
        response: { data }
      } = await err;

      throw data;
    }
  },
  async getGuestsUpdate(json) {
    try {
      const res = await publicInstance.get(
        `${SERVER_API}${PREFIX}/guests-update/`,
        JSON.stringify(json)
      );
      const { data } = await res;
      return data;
    } catch (err) {
      const {
        response: { data }
      } = await err;

      throw data;
    }
  }
};

export default ConfigurationService;
